import { FeatureFlag, useFeatureFlag } from '@/hooks/useFeatureFlags'

import { useAppSelector } from '@/redux/hooks'
import { selectIsDarkMode } from '@/redux/ui/uiSlice'

export type ThemeMode = 'dark' | 'light'

/**
 * Resolves the active theme. Dark is the default (ENG-33713) — a user with no
 * stored preference lands in dark.
 *
 * `showDarkModeToggle` remains the escape hatch: while it is off the toggle is
 * hidden and the app renders light regardless of the stored preference, so we
 * never ship a toggle that does nothing if the rebrand flags aren't all on.
 */
export function useLightMode(): ThemeMode {
  const isShowDarkModeToggleEnabled = useFeatureFlag(
    FeatureFlag.showDarkModeToggle
  )
  const isDarkMode = useAppSelector(selectIsDarkMode)
  return isShowDarkModeToggleEnabled && isDarkMode ? 'dark' : 'light'
}
